export const Head = props => false

Head.mdxDeckHead = true

export default Head
